import { Button } from "@/components/ui/button";
import { ShinyButton } from "@/components/ui/shiny-button";
import { ArrowRight, Sparkles, ShieldCheck, Calendar, MessageCircle } from "lucide-react";

function WaBubble({ side, children, time, highlight }) {
  if (side === "left") {
    return (
      <div style={{ display:"flex" }}>
        <div style={{ maxWidth:"82%", background:"rgba(255,255,255,0.07)", border:"1px solid rgba(255,255,255,0.06)", borderRadius:"14px 14px 14px 3px", padding:"5px 9px", fontSize:10, color:"#e2e8f0", lineHeight:1.4 }}>
          {children}
          <div style={{ fontSize:8, color:"#64748b", marginTop:2, textAlign:"right" }}>{time}</div>
        </div>
      </div>
    );
  }
  return (
    <div style={{ display:"flex", justifyContent:"flex-end" }}>
      <div style={{ maxWidth:"84%", background:highlight?"rgba(37,99,235,0.2)":"#005C4B", border:highlight?"1px solid rgba(59,130,246,0.3)":"none", borderRadius:"14px 14px 3px 14px", padding:"5px 9px", fontSize:10, color:highlight?"#f1f5f9":"white", lineHeight:1.4 }}>
        {children}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"flex-end", gap:3, marginTop:2 }}>
          <span style={{ fontSize:8, color:"#94a3b8" }}>{time}</span>
          <svg width="16" height="11" viewBox="0 0 18 11" fill="none"><path d="M1 5.5L4.5 9L11 2" stroke="#60a5fa" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M7 5.5L10.5 9L17 2" stroke="#60a5fa" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
      </div>
    </div>
  );
}

function PhoneMockup() {
  return (
    <div style={{ width:260, borderRadius:36, background:"linear-gradient(160deg,#4b5563,#1f2937)", padding:3, boxShadow:"0 40px 80px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.1)", position:"relative" }}>
      <div style={{ position:"absolute", left:-4, top:80, width:4, height:28, borderRadius:"4px 0 0 4px", background:"#374151" }} />
      <div style={{ position:"absolute", left:-4, top:120, width:4, height:44, borderRadius:"4px 0 0 4px", background:"#374151" }} />
      <div style={{ position:"absolute", left:-4, top:176, width:4, height:44, borderRadius:"4px 0 0 4px", background:"#374151" }} />
      <div style={{ position:"absolute", right:-4, top:118, width:4, height:60, borderRadius:"0 4px 4px 0", background:"#374151" }} />
      <div style={{ borderRadius:34, overflow:"hidden", background:"#111827" }}>
        <div style={{ background:"#075E54", padding:"8px 16px 6px", display:"flex", alignItems:"center", justifyContent:"space-between", position:"relative" }}>
          <span style={{ fontSize:10, color:"rgba(255,255,255,0.8)", fontWeight:600 }}>9:41</span>
          <div style={{ width:72, height:18, background:"#000", borderRadius:12, position:"absolute", left:"50%", transform:"translateX(-50%)", top:0 }} />
          <div style={{ display:"flex", alignItems:"center", gap:3 }}>
            <div style={{ display:"flex", gap:2, alignItems:"flex-end" }}>
              {[5,8,11,11].map((h,i) => <div key={i} style={{ width:3, height:h, background:"rgba(255,255,255,0.8)", borderRadius:2 }} />)}
            </div>
            <div style={{ width:16, height:9, border:"1.5px solid rgba(255,255,255,0.6)", borderRadius:3, padding:1 }}>
              <div style={{ width:"70%", height:"100%", background:"rgba(255,255,255,0.8)", borderRadius:2 }} />
            </div>
          </div>
        </div>
        <div style={{ background:"#075E54", padding:"7px 10px", display:"flex", alignItems:"center", gap:9 }}>
          <div style={{ width:32, height:32, borderRadius:"50%", background:"linear-gradient(135deg,#3b82f6,#06b6d4)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, color:"white", flexShrink:0 }}>S</div>
          <div>
            <div style={{ fontSize:12, fontWeight:600, color:"white" }}>Sofia · Automia</div>
            <div style={{ fontSize:10, color:"#86efac", display:"flex", alignItems:"center", gap:3 }}>
              <span style={{ width:5, height:5, borderRadius:"50%", background:"#4ade80", display:"inline-block" }} />online
            </div>
          </div>
        </div>
        <div style={{ background:"#0d1117", padding:"8px 7px", minHeight:320, display:"flex", flexDirection:"column", gap:7 }}>
          <div style={{ textAlign:"center" }}>
            <span style={{ fontSize:9, color:"#64748b", background:"rgba(255,255,255,0.05)", borderRadius:99, padding:"2px 8px" }}>Hoje</span>
          </div>
          <WaBubble side="left" time="14:21">Olá, queria marcar uma limpeza facial para sexta</WaBubble>
          <WaBubble side="right" time="14:21">Claro! Temos disponibilidade às <strong style={{color:"#93c5fd"}}>10h</strong> ou às <strong style={{color:"#93c5fd"}}>14h</strong>. Qual prefere?</WaBubble>
          <WaBubble side="left" time="14:22">14h perfeito</WaBubble>
          <WaBubble side="right" time="14:22" highlight>
            <div style={{ fontSize:9, color:"#6ee7b7", marginBottom:3, display:"flex", alignItems:"center", gap:3 }}>
              <Calendar style={{ width:9, height:9 }} />Marcação confirmada
            </div>
            Marcação confirmada ✓ Até sexta!
          </WaBubble>
        </div>
        <div style={{ background:"#0d1117", borderTop:"1px solid rgba(255,255,255,0.06)", padding:"7px", display:"flex", alignItems:"center", gap:7 }}>
          <div style={{ flex:1, background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:99, padding:"5px 10px", fontSize:10, color:"#64748b" }}>Mensagem</div>
          <div style={{ width:26, height:26, borderRadius:"50%", background:"#075E54", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="white"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
          </div>
        </div>
        <div style={{ background:"#0d1117", padding:"5px 0", display:"flex", justifyContent:"center" }}>
          <div style={{ width:72, height:3, borderRadius:99, background:"rgba(255,255,255,0.15)" }} />
        </div>
      </div>
    </div>
  );
}

export default function Hero({ onDemoClick }) {
  return (
    <section
      role="banner"
      data-testid="hero-section"
      className="overflow-x-hidden bg-[#050B14]"
    >
      <div className="pb-24 pt-12 md:pb-32 lg:pb-56 lg:pt-44">
        <div className="relative mx-auto flex max-w-6xl flex-col px-6 lg:grid lg:grid-cols-2 lg:items-center lg:gap-12">

          {/* Text — centered on mobile, left on desktop */}
          <div className="mx-auto max-w-lg text-center lg:mx-0 lg:text-left">

            <div
              data-testid="hero-overline"
              className="animate-fade-in opacity-0 inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full border border-white/10 bg-white/[0.04] text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.2em] text-blue-300"
              style={{ animationDelay: "0.1s" }}
            >
              <Sparkles className="h-3 w-3 sm:h-3.5 sm:w-3.5" />
              IA para WhatsApp · Portugal
            </div>

            <h1
              data-testid="hero-title"
              className="animate-fade-in opacity-0 mt-8 max-w-2xl text-balance text-5xl leading-[1.05] tracking-tighter text-white md:text-6xl lg:mt-16 xl:text-7xl"
              style={{ animationDelay: "0.2s" }}
            >
              Mais marcações,<br />menos trabalho,{" "}
              <span className="text-gradient-blue">sem esforço.</span>
            </h1>

            <p
              data-testid="hero-subtitle"
              className="animate-fade-in opacity-0 mt-8 max-w-2xl text-pretty text-lg text-slate-400 leading-relaxed"
              style={{ animationDelay: "0.35s" }}
            >
              A Automia atende o WhatsApp da sua clínica de estética, marca consultas no Google Calendar e liberta-o para o que realmente importa. Em Português. 24 horas por dia.
            </p>

            <div
              className="animate-fade-in opacity-0 mt-12 flex flex-col items-center justify-center gap-3 sm:flex-row lg:justify-start"
              style={{ animationDelay: "0.5s" }}
            >
              <Button
                data-testid="hero-cta-demo"
                onClick={onDemoClick}
                className="btn-primary-glow text-white border-0 rounded-full h-12 px-7 text-base font-medium group w-full sm:w-auto"
              >
                Experimente 7 dias grátis
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
              <ShinyButton
                href="#como-funciona"
                data-testid="hero-cta-how"
                className="inline-flex items-center justify-center h-12 px-6 w-full sm:w-auto"
              >
                Ver como funciona
              </ShinyButton>
            </div>

            <div
              data-testid="hero-trust-row"
              className="animate-fade-in opacity-0 mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-x-6 gap-y-3 text-sm sm:text-base text-slate-400"
              style={{ animationDelay: "0.65s" }}
            >
              <div className="flex items-center gap-1.5"><ShieldCheck className="h-4 w-4 text-blue-400" />Poupa horas por semana</div>
              <div className="flex items-center gap-1.5"><MessageCircle className="h-4 w-4 text-cyan-400" />Mais marcações</div>
              <div className="flex items-center gap-1.5"><Calendar className="h-4 w-4 text-blue-400" />Disponível 24/7</div>
            </div>
          </div>

          {/* Phone mockup — centered in right column on desktop, stacked on mobile */}
          <div
            className="animate-fade-up opacity-0 order-first mt-10 mb-10 flex justify-center lg:order-last lg:mt-0 lg:mb-0"
            style={{ animationDelay: "0.3s" }}
          >
            <PhoneMockup />
          </div>

        </div>
      </div>
    </section>
  );
}
